import React from 'react';
import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';
import { KVRows } from '../shared/KVRows.jsx';

export function LookupInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });

  // Draft rows live locally, same reason as Rename's draft state: a row
  // KVRows just added (or that only has a key typed so far) has an empty
  // side, so committing straight from it filtered that row right back out
  // on every render — "Add row" looked like it did nothing, since the
  // blank row it appended never survived the round trip through config.
  const committed = Object.entries(c.map || {});
  const [rows, setRows] = React.useState(committed.length ? committed : [['', '']]);
  const lastCommitted = React.useRef(JSON.stringify(committed));
  React.useEffect(() => {
    const now = JSON.stringify(committed);
    if (now !== lastCommitted.current) {
      lastCommitted.current = now;
      setRows(committed.length ? committed : [['', '']]);
    }
  }, [step.id, c.map]); // eslint-disable-line react-hooks/exhaustive-deps
  const commitRows = (next) => {
    setRows(next.length ? next : [['', '']]);
    const map = Object.fromEntries(next.filter(([k]) => k !== ''));
    lastCommitted.current = JSON.stringify(Object.entries(map));
    u({ map });
  };

  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel hint="Leave empty to overwrite the source column">Output column</FieldLabel>
      <TextInput mono value={c.target} onChange={(v) => u({ target: v })} placeholder={c.column || 'mapped'} />
      <FieldLabel>Mapping</FieldLabel>
      <KVRows
        entries={rows}
        onChange={commitRows}
        keyPlaceholder="incoming value"
        valuePlaceholder="mapped to"
      />
      <FieldLabel>Unmapped values</FieldLabel>
      <Segmented
        value={c.unmapped || 'keep'}
        onChange={(v) => u({ unmapped: v })}
        options={[
          { value: 'keep', label: 'Keep original' },
          { value: 'null', label: 'Set null' },
          { value: 'drop', label: 'Drop row' },
        ]}
      />
    </div>
  );
}
